import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareAlignUpIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 17 15' {...props}>
    <path
      d='M4 1v3H1V1h3zm1-1H0v5h5V0zM10 11v3H7v-3h3zm1-1H6v5h5v-5zM16 8v3h-3V8h3zm1-1h-5v5h5V7zM17 0h-1v1h1V0zm-3 0h-1v1h1V0zm-3 0h-1v1h1V0zM8 0H7v1h1V0zM8.5 2L7 4h1v5h1V4h1L8.5 2zM14.5 2L13 4h1v2h1V4h1l-1.5-2z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M4 1v3H1V1h3zm1-1H0v5h5V0zM10 1v3H7V1h3zm1-1H6v5h5V0zM16 1v3h-3V1h3zm1-1h-5v5h5V0z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const AlignUpIcon = memo(BareAlignUpIcon);
